import React from 'react'
import { ClickAwayListener, Typography, useMediaQuery, useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import StatusTag from 'redesign/components/atoms/status-tag'
import Tooltip from 'redesign/components/organisms/Tooltip'
import { useTooltipListener } from 'redesign/components/organisms/Tooltip/use-tooltip-listener'
import { TOOLTIP_VERTICAL_SPACING } from './constants'
import type { TimelineBadgeProps } from './types'

const TimelineBadge: React.FC<TimelineBadgeProps> = ({
  variant,
  text,
  testId = 'timeline-badge',
  tooltipText = '',
  tooltipPlacement = 'bottom',
  skipTooltipText = false,
}) => {
  const { t } = useFavurTranslation()
  const { breakpoints } = useTheme()
  const isSmallScreen = useMediaQuery(breakpoints.down('sm'))
  const { openTooltip, setOpenTooltip } = useTooltipListener()
  const hasTooltip = Boolean(tooltipText)
  const handleTooltip = (state: boolean) => {
    if (!hasTooltip || skipTooltipText) return

    setOpenTooltip(state)
  }

  return (
    <Tooltip
      disableFocusListener
      disableHoverListener
      disableTouchListener
      verticalSpacing={TOOLTIP_VERTICAL_SPACING}
      isSmallScreen={isSmallScreen}
      onClick={() => handleTooltip(true)}
      open={openTooltip}
      placement={tooltipPlacement}
      arrow
      title={
        <ClickAwayListener onClickAway={() => handleTooltip(false)}>
          <Typography>{t(tooltipText)}</Typography>
        </ClickAwayListener>
      }
    >
      <div>
        <StatusTag label={t(text)} variant={variant} testId={testId} onClick={() => {}} isIconFilled />
      </div>
    </Tooltip>
  )
}

export default TimelineBadge
